import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'core/store/Store';
import { formatDate } from 'core/utils/DateUtils';

export interface ItinerayState {
  date: string;
  courier: number | null;
  itineraryVersionId: any;
  clickedDeliveryId: any;
  hoveredDeliveryId: any;
}

const initialState: ItinerayState = {
  date: formatDate(new Date()),
  courier: null,
  itineraryVersionId: null,
  clickedDeliveryId: null,
  hoveredDeliveryId: null,
};

export const itinerarySlice = createSlice({
  name: 'itinerarySlice',
  initialState,
  reducers: {
    setDate: (state, action: PayloadAction<string>) => ({
      ...state,
      date: action.payload,
    }),
    setCourier: (state, action: PayloadAction<number | null>) => ({
      ...state,
      courier: action.payload,
    }),
    setItineraryVersionId: (state, action: PayloadAction<any>) => ({
      ...state,
      itineraryVersionId: action.payload,
    }),
    setClickedDeliveryId: (state, action: PayloadAction<any>) => ({
      ...state,
      clickedDeliveryId: action.payload,
    }),
    setHoveredDeliveryId: (state, action: PayloadAction<any>) => ({
      ...state,
      hoveredDeliveryId: action.payload,
    }),
  },
});

export const dateSelector = (state: RootState) => state.itineraryReducer.date;
export const courierSelector = (state: RootState) =>
  state.itineraryReducer.courier;
export const selectedItineraryIdSelector = (state: RootState) =>
  state.itineraryReducer.itineraryVersionId;
export const selectClickedDeliveryId = (state: RootState) =>
  state.itineraryReducer.clickedDeliveryId;
export const selectHoveredDeliveryId = (state: RootState) =>
  state.itineraryReducer.hoveredDeliveryId;
export const {
  setDate,
  setCourier,
  setItineraryVersionId,
  setClickedDeliveryId,
  setHoveredDeliveryId,
} = itinerarySlice.actions;
export default itinerarySlice.reducer;
